// extracted by mini-css-extract-plugin
export default {"grey200":"#eeeeee","palette":"ColorPalette_palette__kUc60"};